import { useTranslation } from "react-i18next";

import { useAllRooms } from "../hooks/use-rooms";
import { ErrorScreenWithText } from "../partials/error-screen";
import { LoadingScreenWithText } from "../partials/loading-screen";
import { PagePartial } from "../partials/page-partial";
import { RoomSwitch } from "../partials/room-switch";

export const RoomsPage = () => {
  const { t } = useTranslation();
  const { error, isLoading, rooms } = useAllRooms();

  if (isLoading) return <LoadingScreenWithText />;

  if (error) return <ErrorScreenWithText error={error} />;

  return (
    <PagePartial title={t("page.rooms")}>
      <RoomSwitch isLoading={isLoading} rooms={rooms} />
    </PagePartial>
  );
};
